import { render, staticRenderFns } from "./modalCreateBlock.vue?vue&type=template&id=4668145e&scoped=true"
import script from "./modalCreateBlock.vue?vue&type=script&lang=js"
export * from "./modalCreateBlock.vue?vue&type=script&lang=js"
import style0 from "./modalCreateBlock.vue?vue&type=style&index=0&id=4668145e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4668145e",
  null
  
)

export default component.exports